import { idGenerator } from '@model/utils';

export default {
    consultationId: (consultationId: number) => {
        return idGenerator.formatConsultationId(consultationId);
    }
}